module.exports = __webpack_public_path__ + "img/acsi-logo.9ca8428a.jpg";